import React from 'react';
import { HighlightedText } from './styles';

interface TranscriptParagraph {
    text: string;
    start: number;
    end: number;
}

interface HighlightedParagraphProps {
    paragraph: TranscriptParagraph;
    currentTime: number;
    highlightColor: string;
}

const HighlightedParagraph: React.FC<HighlightedParagraphProps> = ({ paragraph, currentTime, highlightColor }) => {
    const textParts = paragraph.text.split('/');
    const isHighlighted = currentTime >= paragraph.start && currentTime < paragraph.end;

    return (
        <HighlightedText highlight={isHighlighted.toString()} color={highlightColor}>
            {textParts.map((part, index) => (
                <React.Fragment key={index}>
                    {part}
                    {index < textParts.length - 1 && <br />}
                </React.Fragment>
            ))}
        </HighlightedText>
    );
};

export default HighlightedParagraph;
